module.exports = "/_next/static/images/de60be8e801043e83ff67d95e760eb51-press-media.jpg";